import { render, staticRenderFns } from "./IconLibWidget.vue?vue&type=template&id=6d20e1fa&scoped=true&xmlns%3Av-clipboard=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./IconLibWidget.vue?vue&type=script&lang=js&"
export * from "./IconLibWidget.vue?vue&type=script&lang=js&"
import style0 from "./IconLibWidget.vue?vue&type=style&index=0&id=6d20e1fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d20e1fa",
  null
  
)

export default component.exports